import { render, staticRenderFns } from "./posterPage.vue?vue&type=template&id=13ebbcc3&scoped=true"
import script from "./posterPage.vue?vue&type=script&lang=js"
export * from "./posterPage.vue?vue&type=script&lang=js"
import style0 from "./posterPage.vue?vue&type=style&index=0&id=13ebbcc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ebbcc3",
  null
  
)

export default component.exports